var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"500px"}},[(_vm.loading)?_c('StateDisplay',{attrs:{"loading":_vm.loading}}):_c('div',[_c('ExchangeRates',{attrs:{"settings":_vm.settings}}),_c('GatewayCharges',{staticClass:"mt-6",attrs:{"settings":_vm.settings}}),_c('AdditionalCosts',{staticClass:"mt-6 mb-12",attrs:{"settings":_vm.settings}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }